import fr from 'facet-rest';
import { BaseOverrideNoHidden } from '../../../BaseOverride';

export default fr.metaOverride({ base: BaseOverrideNoHidden });
